import React, { useEffect, useState } from "react";
import { Table, Modal } from "antd";
import { IoSearch } from "react-icons/io5";
import { FiEdit, FiTrash } from "react-icons/fi";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteGiftCard, giftCardSearch } from "../../../redux/giftCardSlice";

const GiftCards = ({ allProducts, loading }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [products, setProducts] = useState(allProducts);
  const [searchValue, setSearchValue] = useState("");

  const dispatch = useDispatch();
  const store = useSelector((state) => state?.giftCard);
  const searchedGiftCard = store?.searchedGiftCards;

  useEffect(() => {
    if (searchValue !== "") {
      setProducts(searchedGiftCard);
    } else {
      setProducts(allProducts);
    }
  }, [allProducts, searchedGiftCard]);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const confirm = (id) => {
    Modal.confirm({
      title: "Are you sure!",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      async onOk() {
        await dispatch(deleteGiftCard(id));
      },
      cancelText: "No",
    });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Status",
      dataIndex: "status",
    },

    {
      title: "",
      dataIndex: "action",
    },
  ];
  const data = [];

  products.map((product) => {
    data.push({
      key: product?._id,
      product: (
        <div className='productDetail'>
          {product?.media !== "NULL" ? (
            <img src={product?.media?.[0]} className='productImg' />
          ) : (
            <div className='productImgPlaceholder'></div>
          )}

          {/* <Link to={`/products/${product?._id}`}> */}
          <span className='productName'>{product?.giftCardTitle}</span>
          {/* </Link> */}
        </div>
      ),
      description: (
        <p
          className='productDescription'
          dangerouslySetInnerHTML={{
            __html: product?.giftCardDescription,
          }}></p>
      ),

      status:
        product?.status == true ? (
          <p className='successBadge'>Active</p>
        ) : (
          <p className='dangerBadge'>Deactive</p>
        ),
      action: (
        <div className='action'>
          <Link to={`/gift-cards/${product?._id}/edit`}>
            <FiEdit
              className='actionBtn'
              // onClick={() => {
              //   Modal.info({
              //     title: "This feature is under development",
              //     onOk() {},
              //   });
              // }}
            />
          </Link>
          <FiTrash
            className='actionBtn'
            onClick={() => confirm(product?._id)}
          />
        </div>
      ),
    });
  });

  return (
    <>
      <div className='productsTableContainer'>
        <div className='productsTableHeader'>
          <div className='productsSearch'>
            <IoSearch className='searchIcon' />
            <input
              type='text'
              placeholder='Search gift card products'
              onChange={(e) => {
                setSearchValue(e.target.value);
                dispatch(
                  giftCardSearch({
                    name: e.target.value,
                  })
                );
                // setProducts(
                //   allProducts.filter((product) =>
                //     String(product?.giftCardTitle)
                //       .toUpperCase()
                //       .includes(String(e.target.value).toUpperCase())
                //   )
                // );
              }}
            />
          </div>
        </div>

        <Table
          className='customerTable'
          rowSelection={rowSelection}
          loading={loading}
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 7,
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>
    </>
  );
};

export default GiftCards;
